import { useState, useCallback } from 'react';

import { setPendingLoginEvent } from 'src/services';
import { baseApiUrl } from 'src/utils';

export interface IUseGoogleOAuthOptions {
  onError?: (error: any) => void;
}

export function useGoogleOAuth(options: IUseGoogleOAuthOptions): {
  isReady: boolean;
  signIn: () => void;
  isLoading: boolean;
} {
  const { onError } = options;
  const [isLoading, setIsLoading] = useState(false);

  const signIn = useCallback(() => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);

      const googleAuthUrl = `${baseApiUrl}/auth/google`;

      const currentState = {
        returnUrl: window.location.pathname + window.location.search,
      };
      sessionStorage.setItem('googleAuthState', JSON.stringify(currentState));

      setPendingLoginEvent('google');

      window.location.href = googleAuthUrl;
    } catch (error) {
      setIsLoading(false);
      onError?.(error);
    }
  }, [isLoading, onError]);

  return {
    isReady: true,
    signIn,
    isLoading,
  };
}
